import {createAction} from "@reduxjs/toolkit";
import {GridState} from "@ag-grid-community/core";
import {DriverActivityFilterFormValues} from "@ots-frontend/ots-ui";

export const setDriverActivityDayPageFilter = createAction<DriverActivityFilterFormValues>("ui/driver-activity-day-page/setFilter");
export const setDriverActivityDayPageState = createAction<GridState>("ui/driver-activity-day-page/setState");
export const toggleDriverActivityDayPagePerson = createAction<string>("ui/driver-activity-day-page/togglePerson");
export const clearToggleDriverActivityDayPagePerson = createAction<void>("ui/driver-activity-day-page/clearTogglePerson");
